var PS_METRIC_ICON = (label, platform = "") => {
    // 21.10.2026: іконка метрики за підписом будь-якою мовою магазину - дзеркало snippets/metric-icon-key.liquid (той самий порядок). var, бо ці 3 файли можуть бути на одній сторінці
    const l = String(label).toLowerCase(), pl = String(platform).toLowerCase()
    if (/platform|plattform|plataforma|piattaform|платформ/.test(l)) return "platforms"
    if (/play|stream|стрим|стрім|прослух|прослуш|reproduc|riproduz|reproduç|wiedergab/.test(l)) return "plays"
    if (/view|aufruf|vista|visualiz|просмотр|перегляд/.test(l)) return "views"
    if (/subscriber|abonnent|suscriptor|iscritt|subscritor/.test(l)) return "subscribers"
    if (/подписчик|підписник/.test(l)) return pl.includes("youtube") ? "subscribers" : "followers"
    if (/follow|fan|seguidor/.test(l)) return "followers"
    if (/save|guardad|salvatagg|salvament|gespeichert|сохранен|збережен/.test(l)) return "saves"
    if (/like|лайк|вподоба|gusta|mi piace|gosto/.test(l)) return "likes"
    if (/listener|hörer|oyente|ascoltator|ouvinte|слушател|слухач/.test(l)) return "listeners"
    if (/repost|репост/.test(l)) return "reposts"
    if (/comment|kommentar|comentar|комментар|коментар/.test(l)) return "comments"
    if (/blog|блог/.test(l)) return "music-blogs"
    if (/radio|station|радио|радіо/.test(l)) return "radio-airplay"
    return ""
}
// 21.10.2026: «50 000» (ru/uk) - групи тисяч через пробіл лишаються в числі (нерозривний пробіл), не йдуть у підпис
var PS_NUM_RE = /^(~?[\d][\d.,:]*(?:[\s\u00a0\u202f]\d{3}(?!\d))*\s*%?(?:\s*[\u2013\u2014-]\s*[\d][\d.,]*)?\s*[kKmM]?)[\s-]*(.*)$/
var PS_NUM_FMT = (s) => String(s).replace(/(\d)[\s\u00a0\u202f]+(?=\d{3}(?!\d))/g, "$1#").replace(/\s+/g, "").replace(/#/g, "\u00a0")

function formatPrice(price) {
  const value = price / 100
  return `${value.toFixed(2)}$`
}

function handleize(str = "") {
  return str
    .toLowerCase()
    .trim()
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
}

function renderStars(rating = 0) {
  const full = Math.floor(rating)
  const half = rating - full >= 0.5
  const drawn = full + (half ? 1 : 0)
  const empty = 5 - drawn

  let html = ""

  for (let i = 0; i < full; i++) {
    html += `<div class="svc-ico svc-ico--star"></div>`
  }

  if (half) {
    html += `<div class="svc-ico svc-ico--star-half"></div>`
  }

  for (let i = 0; i < empty; i++) {
    html += `<div class="svc-ico svc-ico--star-empty"></div>`
  }

  return html
}

function renderVariants(variants = []) {
  return variants.map(v => `
    <button class="svc-card__variant" data-id="${v.id}" data-price="${v.price}">
      ${v.title}
    </button>
  `).join("")
}

function renderSubproducts(subproducts = [], cardType = "default") {
  return subproducts.map(sp => `
    <button
      class="svc-card__subproduct"
      data-title="${sp.title}"
      data-variants='${JSON.stringify(sp.variants).replace(/"/g, '&quot;')}'
    >
      <span class="svc-card__subproduct-title">${sp.title}</span>
      ${cardType !== "default" ? `<span class="svc-card__subproduct-price"></span>` : ""}
    </button>
  `).join("")
}


// 05.09.2026: бандл-картка v13 у JS-рендері (Recently Viewed, Complete Your Promotion, рекомендації) - дзеркало
// snippets/bundle-title-normalize + product-card-new: назва/тір/бокс метрик з системними іконками, 4+ метрик → компактний рядок
function parseBundleTitle(title = "") {
  let t = String(title).split(" — ")[0].replace(/ – | - /g, " ").replace(/; /g, ": ").replace(/ \+ /g, " / ").trim()
  if (!t.includes(" / ")) return null
  let fm = t.split(" / ")[0]
  if (fm.includes(":")) fm = fm.split(":").pop()
  if (!fm.trim().split(" ").some(w => /^\d/.test(w))) return null
  let name, spec
  if (t.includes(":")) { name = t.split(":")[0]; spec = t.split(":").slice(1).join(":") }
  else { const words = t.split(" "); const i = words.findIndex(w => /^\d/.test(w)); name = words.slice(0, i).join(" "); spec = words.slice(i).join(" ") }
  // 10.09.2026: мережа лишається окремим верхнім рядком назви (дзеркало product-card-new: bundle_platform)
  name = name.replace(/[\u{1F331}\u{1F33F}\u2618\uFE0F\u2728\u{1F525}]/gu, "").trim()
  const pm = name.match(/^(Spotify|YouTube|Instagram|TikTok|Facebook|SoundCloud|S-Cloud|Mixcloud)\s+/)
  const platform = pm ? pm[1] : ""
  // 23.09.2026: список мереж має збігатися зі snippets/product-card-new.liquid (Liquid-рендер)
  name = name.replace(/Spotify |YouTube |Instagram |TikTok |Facebook |SoundCloud |S-Cloud |Mixcloud |Audiomack |Beatport |Deezer |Tidal |Twitch |Threads |Bandcamp |Pandora |Traxsource /g, "").trim()
  let tier = handleize(name.toLowerCase().replace("standart", "standard"))
  // 08.09.2026: «Artist Premium» → тір = ОСТАННЄ слово (як у product-card-new), інакше клас виходив
  // svc-card--tier-artist-premium і правила тіру (кільце іконки, колір ціни) не спрацьовували
  tier = tier.split("-").pop()
  tier = ({ starter: "basic", booster: "standard", viral: "premium", catch: "ultra" })[tier] || tier
  const items = spec.split("/").map(x => x.trim()).filter(Boolean).map(v => {
    // 21.10.2026: число з групами тисяч через пробіл (ru/uk) + іконка будь-якою мовою (PS_METRIC_ICON)
    const m = v.match(PS_NUM_RE)
    const num = m ? PS_NUM_FMT(m[1]) : v.split(" ")[0]
    const rest = m ? m[2].trim() : v.split(" ").slice(1).join(" ")
    let ic = PS_METRIC_ICON(rest, platform)
    if (ic === "platforms") ic = ""
    return { num, rest, ic }
  })
  return { name, platform, tier, items, full: t }
}

function renderBundleSpec(items, product) {
  // 08.09.2026: Artist Pack - перший рядок «5 Platforms» замінюємо на фірмові логотипи платформ
  const packs = product && product.pack_platforms && product.pack_platforms.length ? product.pack_platforms : null
  const ico = (ic) => ic ? `<span class="svc-spec-ico menu-item-icon ico-ico-${ic}"></span>` : `<span class="svc-spec-ico svc-spec-ico--check"></span>`
  const row = (it) => {
    if (packs && PS_METRIC_ICON(it.rest) === "platforms") {
      const logos = packs.map(p => `<span class="${p}-promotion"><span class="svc-card__image"></span></span>`).join("")
      return `<li class="svc-card__spec-row--platforms"><span class="svc-card__spec-platforms" aria-hidden="true">${logos}</span><span class="svc-card__spec-lab">${it.num} ${it.rest.toLowerCase()}</span></li>`
    }
    return `<li>${ico(it.ic)}<b class="svc-card__spec-num">${it.num}</b><span class="svc-card__spec-lab">${it.rest}</span></li>`
  }
  if (items.length <= 3) {
    return items.map(it => row(it)).join("")
  }
  // 11.09.2026: рівно 4 метрики (не пак) - два рядки по парі з підписами (дзеркало product-card-new)
  const pairHtml = (it) => `<span class="svc-card__spec-pair" title="${it.num} ${it.rest}">${ico(it.ic)}<b class="svc-card__spec-num">${it.num}</b>${it.rest ? `<span class="svc-card__spec-lab">${it.rest}</span>` : ""}</span>`
  if (items.length === 4 && !packs) {
    return `<li class="svc-card__spec-row--pair">${pairHtml(items[0])}${pairHtml(items[1])}</li><li class="svc-card__spec-row--pair">${pairHtml(items[2])}${pairHtml(items[3])}</li>`
  }
  const head = items.slice(0, 2).map(it => row(it)).join("")
  const compact = items.slice(2).map(it => `<span class="svc-card__spec-pair" title="${it.num} ${it.rest}">${ico(it.ic)}<b class="svc-card__spec-num">${it.num}</b>${it.rest ? `<span class="svc-card__spec-lab">${it.rest}</span>` : ""}</span>`).join("")
  return head + `<li class="svc-card__spec-row--compact">${compact}</li>`
}

function renderBundleCard(product, bundle, recommendationContext = {}) {
  const card = document.createElement("div")
  card.className = [
    "svc-card", "svc-card--bundle", `svc-card--tier-${bundle.tier}`,
    product.bundle_featured ? "svc-card--featured" : "",
    product.handle, product.icon_class,
    ...(product.collections || []).map(c => handleize(c.title))
  ].filter(Boolean).join(" ")
  card.dataset.cardType = product.card_type
  card.dataset.collection = product.collection || ""
  card.dataset.platform = product.icon_class || ""
  card.dataset.recommendationBlock = recommendationContext.block || ""
  card.dataset.recommendationSource = recommendationContext.source || ""
  card.dataset.productId = product.id
  card.dataset.productRole = product.catalog_role || ""
  card.dataset.position = recommendationContext.position || ""
  const badges = `
    ${product.exclusive ? `<span class="svc-card__badge svg-card__badge--exlusive">Exclusive</span>` : ""}
    ${product.is_best_seller ? `<span class="svc-card__badge svg-card__badge--bestseller">${window.translations.product.best_seller}</span>` : ""}
    ${product.is_sale ? `<span class="svc-card__badge svg-card__badge--sale">${window.translations.product.sale}</span>` : ""}`
  const rating = product.review_count > 0
    ? `<div class="svc-card__rating">${renderStars(product.average_rating)}<span>(${product.review_count})</span></div>`
    : `<div class="svc-card__rating svc-card__rating--empty" aria-hidden="true"></div>`
  const variant = product.variants?.[0] || {}
  // 08.09.2026: Artist Pack - другий екран зі складом (у Liquid-картці він є, у JS-рендері блоків рекомендацій не було)
  const pack = product.pack_items && product.pack_items.length ? product.pack_items : null
  if (pack) card.classList.add("svc-card--pack")
  card.innerHTML = `
    <div class="svc-card__screen svc-card__screen--1 is-active">
      <div class="svc-card__header svc-card__header--screen-1">
        <div class="svc-card__badges">${badges}</div>
        <a href="${String(product.url).split("?")[0]}" class="svc-card__image-link" data-recommendation-action="product-click" aria-label="${bundle.full}"><div class="svc-card__image"></div></a>
        <a href="${String(product.url).split("?")[0]}" class="svc-card__title svc-card__title--bundle${bundle.platform ? " svc-card__title--two" : ""}" data-recommendation-action="product-click" title="${bundle.full}">${bundle.platform ? `<span class="svc-card__title-platform">${bundle.platform}</span> <span class="svc-card__title-tier">${bundle.name}</span>` : bundle.name}</a>
        <ul class="svc-card__spec" aria-label="${bundle.full}">${renderBundleSpec(bundle.items, product)}</ul>
        ${rating}
      </div>
      <div class="svc-card__footer">
        <div class="svc-card__price-label${product.pack_hook ? " svc-card__pack-total svc-card__pack-hook" : ""}">${product.pack_hook ? `<b>${product.pack_hook.reach}</b> ${window.translations.common.est_reach} <span class="svc-card__pack-dot">·</span> <b>${product.pack_hook.impressions}</b> ${window.translations.common.impressions}` : ""}</div>
        <div class="svc-card__price">${formatPrice(product.price)}</div>
        ${pack ? `
        <button class="svc-card__choose btn btn-primary" data-recommendation-action="option-open">
          ${window.translations.action.whats_inside}
          <div class="svc-ico svc-ico--arrow"></div>
        </button>` : `
        <form class="svc-card__form">
          <input type="hidden" name="id" value="${variant.id || ""}">
          <input type="hidden" name="product_title" value="${product.title}">
          <input type="hidden" name="variant_title" value="${variant.title || ""}">
          <input type="hidden" name="price" value="${product.price}">
          <input type="hidden" name="quantity" value="1">
          <input type="hidden" name="collection" value="${product.collection || ""}">
          <button type="button" class="svc-card__buy add_to_cart_button btn btn-primary" data-recommendation-action="add-to-cart">
            ${window.translations.product.add_to_cart}
            <div class="svc-ico svc-ico--arrow"></div>
          </button>
        </form>`}
      </div>
    </div>
    ${pack ? `
    <div class="svc-card__screen svc-card__screen--2 svc-card__screen--pack">
      <div class="svc-card__header svc-card__header--back">
        <div class="svc-card__service-ico"></div>
        <div class="svc-card__header-title">${bundle.name}</div>
        <button class="svc-card__back"><div class="svc-ico svc-ico--close"></div></button>
      </div>
      <div class="svc-card__pack-box">
        <div class="svc-card__pack-label">${window.translations.common.whats_included}</div>
        <ul class="svc-card__pack-list">
          ${pack.map(it => `<li class="svc-card__pack-row ${it.ic}-promotion">
            <span class="svc-card__pack-ico svc-card__image" aria-hidden="true"></span>
            <span class="svc-card__pack-body"><b class="svc-card__pack-name">${it.name}</b><span class="svc-card__pack-spec">${it.spec}</span></span>
          </li>`).join("")}
        </ul>
      </div>
      <div class="svc-card__form-box svc-card__form-box--pack">
        <div class="svg-card__form-box-header">
          <div class="svc-card__price svc-card__price--2">${formatPrice(product.price)}</div>
        </div>
        <form class="svc-card__form">
          <input type="hidden" name="id" value="${variant.id || ""}">
          <input type="hidden" name="product_title" value="${product.title}">
          <input type="hidden" name="variant_title" value="${variant.title || ""}">
          <input type="hidden" name="price" value="${product.price}">
          <input type="hidden" name="quantity" value="1">
          <input type="hidden" name="collection" value="${product.collection || ""}">
          <button type="button" class="svc-card__buy add_to_cart_button btn btn-primary" data-recommendation-action="add-to-cart">
            ${window.translations.product.add_to_cart}
            <div class="svc-ico svc-ico--arrow"></div>
          </button>
        </form>
      </div>
    </div>` : ""}`
  return card
}

function renderCard(product, recommendationContext = {}) {
  const bundle = product.card_type === "simple" ? parseBundleTitle(product.title) : null
  if (bundle && bundle.name) return renderBundleCard(product, bundle, recommendationContext)
  const classes = [
    "svc-card",
    product.handle,
    product.icon_class,
    ...(product.collections || []).map(c => handleize(c.title))
  ].filter(Boolean).join(" ")

  const card = document.createElement("div")

  card.className = classes
  card.dataset.cardType = product.card_type
  card.dataset.collection = product.collection || ""
  card.dataset.recommendationBlock = recommendationContext.block || ""
  card.dataset.recommendationSource = recommendationContext.source || ""
  card.dataset.productId = product.id
  card.dataset.productRole = product.catalog_role || ""
  card.dataset.position = recommendationContext.position || ""

  if (product.card_type === "variants" || product.card_type === "instant") {
    card.dataset.variants = JSON.stringify(product.variants || [])
  }

  const badges = `
    ${product.exclusive ? `<span class="svc-card__badge svg-card__badge--exlusive">Exclusive</span>` : ""}
    ${product.is_best_seller ? `<span class="svc-card__badge svg-card__badge--bestseller">${window.translations.product.best_seller}</span>` : ""}
    ${product.is_sale ? `<span class="svc-card__badge svg-card__badge--sale">${window.translations.product.sale}</span>` : ""}
  `

  const rating = product.review_count > 0
    ? `
      <div class="svc-card__rating">
        ${renderStars(product.average_rating)}
        <span>(${product.review_count})</span>
      </div>
    `
    : ""

  const screen1 = `
    <div class="svc-card__screen svc-card__screen--1 is-active">
      <div class="svc-card__header svc-card__header--screen-1">

        <div class="svc-card__badges">
          ${badges}
        </div>

        <div class="svc-card__image"></div>

        <a href="${String(product.url).split("?")[0]}" class="svc-card__title" data-recommendation-action="product-click">
          ${product.title}
        </a>

        ${product.card_type === "default" && product.subproducts_count > 1
      ? `<div class="svc-card__types-count">${product.subproducts_count} ${window.translations.product.types}</div>`
      : ""
    }

        ${rating}

      </div>

      <div class="svc-card__footer">

        ${product.card_type === "simple"
      ? `
            <div class="svc-card__price-label"></div>
            <div class="svc-card__price">${formatPrice(product.price)}</div>

            <form class="svc-card__form">
              <input type="hidden" name="id" value="${product.variants?.[0]?.id || ""}">
              <input type="hidden" name="product_title" value="${product.title}">
              <input type="hidden" name="variant_title" value="${product.variants?.[0]?.title || ""}">
              <input type="hidden" name="price" value="${product.price}">
              <input type="hidden" name="quantity" value="1">
              <input type="hidden" name="collection" value="${product.collection || ""}">

              <button type="button" class="svc-card__buy add_to_cart_button btn btn-primary" data-recommendation-action="add-to-cart">
                ${window.translations.product.add_to_cart}
                <div class="svc-ico svc-ico--arrow"></div>
              </button>
            </form>
          `
      : `
            <div class="svc-card__price-label">${window.translations.product.from}</div>
            <div class="svc-card__price">${formatPrice(product.price_min)}</div>

            <button class="svc-card__choose btn btn-primary" data-recommendation-action="option-open">
              ${window.translations.product.choose_package}
              <div class="svc-ico svc-ico--arrow"></div>
            </button>
          `
    }

      </div>
    </div>
  `

  const screen2 = (product.card_type === "default" || product.card_type === "variants")
    ? `
      <div class="svc-card__screen svc-card__screen--2">
        <div class="svc-card__header svc-card__header--back">
          <div class="svc-card__service-ico"></div>
          <div class="svc-card__header-title"></div>
          <button class="svc-card__back">
            <div class="svc-ico svc-ico--close"></div>
          </button>
        </div>

        ${product.card_type === "default"
      ? `
            <div class="svc-card__subproduct-box">
              <div class="svc-card__subproduct-label">${window.translations.product.choose_option}</div>

              <button class="svc-card__subproduct-select">
                <span class="svc-card__subproduct-name">Select package</span>
              </button>
            </div>
          `
      : ""
    }

        <div class="svc-card__variants-box">
          <div class="svc-card__variants-label">${window.translations.product.quantity}</div>
          <div class="svc-card__variants">
            ${renderVariants(product.variants || [])}
          </div>
        </div>

        <div class="svc-card__form-box">
          <div class="svg-card__form-box-header">

            <div class="svg-card__input-quantity">
              <button class="svg-card__quantity-btn svg-card__quantity-btn--minus">
                <div class="svc-ico svc-ico--minus"></div>
              </button>

              <input type="text" name="quantity" value="1" class="svg-card__quantity-input">

              <button class="svg-card__quantity-btn svg-card__quantity-btn--plus">
                <div class="svc-ico svc-ico--plus"></div>
              </button>
            </div>

            <div class="svc-card__price svc-card__price--2">$0</div>

          </div>

          <form class="svc-card__form">
            <input type="hidden" name="id">
            <input type="hidden" name="product_title">
            <input type="hidden" name="variant_title">
            <input type="hidden" name="price">
            <input type="hidden" name="compare_at_price">
            <input type="hidden" name="quantity" value="1">
            <input type="hidden" name="collection" value="${product.collection || ""}">

            <button type="button" class="svc-card__buy add_to_cart_button btn btn-primary">
              ${window.translations.product.add_to_cart}
              <div class="svc-ico svc-ico--arrow"></div>
            </button>
          </form>
        </div>
      </div>
    `
    : ""

  const screen3 = `
    <div class="svc-card__screen svc-card__screen--3">
      <div class="svc-card__header svc-card__header--back">
        <div class="svc-card__service-ico"></div>

        <div class="svc-card__header-title">Select Service Type</div>

        <button class="svc-card__back">
          <div class="svc-ico svc-ico--close"></div>
        </button>
      </div>

      <div class="svc-card__subproducts" data-simplebar>
        ${renderSubproducts(product.subproducts || [], product.card_type)}
      </div>
    </div>
  `

  const instantScreen2 = product.card_type === "instant"
    ? `<div class="svc-card__screen svc-card__screen--2"></div>`
    : ""

  card.innerHTML = screen1 + screen2 + instantScreen2 + screen3

  return card
}


function initRecsSwipers() {

  const sliders = document.querySelectorAll('.swiper-recs')

  sliders.forEach(function (sliderEl, index) {

    if (sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true)
    }

    var slides = sliderEl.querySelectorAll('.swiper-slide')
    var slideCount = slides.length
    var wrapper = sliderEl.querySelector('.swiper-wrapper')

    function getSlidesPerView() {
      let w = window.innerWidth
      if (w >= 1000) return 3
      if (w >= 768) return 2
      return 1
    }

    let slidesPerViewNow = getSlidesPerView()
    let enableLoop = slideCount > slidesPerViewNow

    if (!enableLoop) {
      sliderEl.classList.add('loop-disabled')
    } else {
      sliderEl.classList.remove('loop-disabled')
    }

    if (wrapper) {
      if (slideCount > 0 && slideCount < slidesPerViewNow) {
        wrapper.classList.add('swiper-wrapper--centered')
      } else {
        wrapper.classList.remove('swiper-wrapper--centered')
      }
    } else {
      console.warn("[swiper-recs] wrapper not found")
    }

    try {
      let swiper = new Swiper(sliderEl, {
      watchSlidesProgress: true, // 05.09: сусідні слайди ховаються за swiper-slide-visible (єдине рішення слайдерів)
        slidesPerView: 1,
        spaceBetween: 24,
        loopFillGroupWithBlank: false,
        loop: enableLoop,
        pagination: {
          el: sliderEl.querySelector('.swiper-pagination'),
          clickable: true,
          // 08.09.2026: УНІФІКОВАНО - завжди крапки (еталон = слайдер Artist Packs)
          type: 'bullets',
        },
        navigation: enableLoop ? {
          nextEl: sliderEl.querySelector('.swiper-button-next'),
          prevEl: sliderEl.querySelector('.swiper-button-prev'),
        } : {},
        breakpoints: {
          1000: { slidesPerView: 3 },
          768: { slidesPerView: 2 },
          480: { slidesPerView: 1 },
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        }
      })

      swiper.on('touchStart', function () {
        swiper.autoplay && swiper.autoplay.stop()
      })

      // 07.09.2026: після init класи swiper-slide-visible можуть не проставитись (layout ще не фінальний,
      // інший renderSlider перестворює всі слайдери) - CSS ховає невидимі слайди. Дожимаємо update.
      const refresh = () => { try { sliderEl.swiper && sliderEl.swiper.update() } catch (e) {} }
      setTimeout(refresh, 200)
      setTimeout(refresh, 1000)
      window.addEventListener('load', refresh, { once: true })
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => { if (entries.some(e => e.isIntersecting)) { refresh(); io.disconnect() } }, { threshold: 0.1 })
        io.observe(sliderEl)
      }

    } catch (e) {
      console.error("[swiper-recs] INIT ERROR:", e)
    }

  })

}

function initRecsSimplebars(scope = document) {
  const elements = scope.querySelectorAll('.svc-card__subproducts[data-simplebar]')

  elements.forEach(el => {
    if (!el.SimpleBar) {
      new SimpleBar(el)
    }
  })
}

function renderSlider(selector, products, recommendationContext = {}, usedProductIds = new Set()) {

  const slider = document.querySelector(selector)
  if (!slider) return

  const section = slider.closest(".product-recommendations")

  const wrapper = slider.querySelector(".swiper-wrapper")
  if (!wrapper) return

  const uniqueProducts = []

  products.forEach(product => {
    if (!product?.id || usedProductIds.has(product.id)) return
    // 30.10.2026: розпроданий товар не рекомендуємо
    if (product.available === false) return
    uniqueProducts.push(product)
  })

  wrapper.innerHTML = ""

  const minimumItems = recommendationContext.minimumItems || 1

  if (uniqueProducts.length < minimumItems) {
    if (section) section.hidden = true
    return
  }

  uniqueProducts.forEach((product, index) => {
    usedProductIds.add(product.id)

    try {
      const slide = document.createElement("div")
      slide.className = "swiper-slide"

      const card = renderCard(product, {
        ...recommendationContext,
        position: index + 1,
      })

      slide.appendChild(card)
      wrapper.appendChild(slide)

    } catch (error) {
      console.error("[recs-render] renderCard error:", product, error)
    }
  })

  if (section) {
    section.hidden = false
    section.dataset.recommendationBlock = recommendationContext.block || ""
    section.dataset.recommendationSource = recommendationContext.source || ""
  }


  requestAnimationFrame(() => {
    initRecsSwipers()

    if (window.productCardManager) {
      window.productCardManager.initCards(slider)
    }

    requestAnimationFrame(() => {
      initRecsSimplebars(slider)
    })
  })
}

function initRecsRender() {
  if (!window.Recs) {
    return
  }

  let viewed = []
  let top = []

  try {
    viewed = window.Recs.viewed(8)
  } catch (error) {
    console.error("[recs-render] viewed error:", error)
  }

  try {
    top = window.Recs.topPicks(12)
  } catch (error) {
    console.error("[recs-render] topPicks error:", error)
  }

  const usedProductIds = new Set()

  const renderTopPicks = () => {
    try {
      renderSlider(".recs-top", top, {
        block: "top-picks",
        source: "recent-collection-and-best-sellers",
      }, usedProductIds)
    } catch (error) {
      console.error("[recs-render] render .recs-top error:", error)
    }
  }

  const renderRecentlyViewed = () => {
    try {
      renderSlider(".recs-viewed", viewed, {
        block: "recently-viewed",
        source: "local-view-history",
        minimumItems: 2,
      }, usedProductIds)
    } catch (error) {
      console.error("[recs-render] render .recs-viewed error:", error)
    }
  }

  const cartHasBothHistoryAndTopPicks = document.querySelector(".recs-viewed") && document.querySelector(".recs-top")

  if (cartHasBothHistoryAndTopPicks) {
    renderRecentlyViewed()
    renderTopPicks()
  } else {
    renderTopPicks()
    renderRecentlyViewed()
  }

}

document.addEventListener("DOMContentLoaded", () => {
  initRecsRender()
})
